export const IMAGES = {
  hero: 'https://static.lumi.new/32/327a0b2f781992b8aaa31e0678717a4e.jpg',
  team: 'https://static.lumi.new/ae/ae8ca502a192cdbeab3996cafd03c1e7.jpg',
  water: 'https://static.lumi.new/fc/fc6794e62f63612197676c98f27b6189.png',
  technology: 'https://static.lumi.new/67/67f9f7462e1e0580fc1683cff5a66b83.jpg',
  product: 'https://s.alicdn.com/@sc04/kf/H22edb65eb4b24c10b94310d73f98307dk.jpg_720x720Q50.jpg',
}

export const COMPANY = {
  name: 'AquaPure',
  tagline: 'Cleaner Water, Healthier Home',
  email: 'support@aquapurewaterfilter.eu',
}

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
]

export const FAQ_ITEMS = [
  {
    question: 'How difficult is the installation?',
    answer: 'The system installs under your kitchen sink and connects to your existing cold water supply. Most households can complete the setup in under an hour with basic tools. A step-by-step guide is included.',
  },
  {
    question: 'How often do the filters need replacing?',
    answer: 'The main filter cartridge lasts approximately 6 to 12 months depending on your water usage and local water quality. Replacement filters are available directly from our website.',
  },
  {
    question: 'What does the filter reduce?',
    answer: 'The system is designed to reduce common tap water contaminants such as chlorine, sediment, certain heavy metals, and microplastics. Results may vary depending on your local water composition.',
  },
  {
    question: 'Does it work with European plumbing?',
    answer: 'Yes. The system is designed specifically for standard European plumbing connections. Adapters are included for the most common fitting types across EU countries.',
  },
  {
    question: 'What is the warranty?',
    answer: 'Every unit comes with a 2-year manufacturer warranty covering defects in materials and workmanship. Extended warranty options are available at checkout.',
  },
  {
    question: 'Where do you ship?',
    answer: 'We ship across the European Union. Delivery typically takes 3 to 7 business days depending on your location.',
  },
]
